/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import "./assistant-specialist-pill-BBAriyDc.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s } from "lit/decorators.js";
import { repeat as c } from "lit/directives/repeat.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/assistant/assistant-specialists-bar/assistant-specialists-bar.css.js
var l = r(":host{pointer-events:none}.specialists-bar{z-index:1;flex-flow:wrap;justify-content:center;align-items:center;gap:.2rem;width:100%;margin:0;padding:.2rem;font-size:.6rem;list-style:none;transition:transform .3s ease-in-out;display:flex;inset:0 0 auto}.specialists-bar[aria-busy=false]{transform:translateY(-100%)}.specialists-bar[aria-busy=true]{transition-delay:.3s;transform:none}"), u = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = l, this.specialists = [], this.metadata = {}, this._handlePillDone = (e) => {
			let t = e.composedPath()[0];
			document.startViewTransition ? document.startViewTransition(() => t.remove()) : t.remove();
		};
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("pill-done", this._handlePillDone);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("pill-done", this._handlePillDone);
	}
	render() {
		let e = this.specialists.some((e) => e.status === "running");
		return a`
            <ul class="specialists-bar" aria-busy="${e ? "true" : "false"}">
                ${c(this.specialists, (e) => e.id, (e) => {
			let t = this.metadata[e.kind] ?? this.fallback;
			return a`
                            <ptc-ui-assistant-specialist-pill
                                status="${e.status}"
                                label="${t?.label ?? ""}"
                                icon="${t?.icon ?? ""}"
                                color="${t?.color ?? ""}"
                                data-id="${e.id}"
                                style="view-transition-name: specialist-${e.id}"
                            ></ptc-ui-assistant-specialist-pill>
                        `;
		})}
            </ul>
        `;
	}
};
n([s({ type: Array }), t("design:type", Array)], u.prototype, "specialists", void 0), n([s({ type: Object }), t("design:type", typeof Record > "u" ? Object : Record)], u.prototype, "metadata", void 0), n([s({ type: Object }), t("design:type", Object)], u.prototype, "fallback", void 0), u = n([o("ptc-ui-assistant-specialists-bar")], u);
//#endregion
export { u as t };

//# sourceMappingURL=assistant-specialists-bar-CfFwo61J.js.map